<template>
    <b-card no-body>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-card-header>
            <span class="h5">
                CONTRATO -
                <strong>
                    {{
                        contrato.vcCodigoEstruturado
                            ? contrato.vcCodigoEstruturado
                            : ''
                    }}
                    -
                    {{ contrato.fornecedor ? contrato.fornecedor.nome : '' }}
                </strong>
                <b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label class="required">Filial</label>
                        <b-form-select
                            :options="filiais"
                            v-model="filial.codigo"
                            text-field="nome"
                            value-field="codigo"
                            @input="$v.filial.codigo.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label class="required">Tipo Contrato RM</label>
                        <b-form-select
                            :options="tiposContratoRm"
                            v-model="tipoContratoRm.codigo"
                            text-field="descricao"
                            value-field="codigo"
                            @input="$v.tipoContratoRm.codigo.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <!-- <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Tipo para Faturamento RM</label>
                        <b-form-select
                            :options="tiposProdutosFaturamentoRm"
                            v-model="tipoProdutoFaturamentoRm.codigo"
                            text-field="descricao"
                            value-field="codigo"
                            @input="$v.tipoProdutoFaturamentoRm.codigo.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col> -->
                <!-- <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Natureza</label>
                        <model-list-select
                            :list="tiposNatureza"
                            option-text="descricao"
                            option-value="codigo"
                            v-model="tipoNatureza.codigo"
                            @input="$v.tipoNatureza.codigo.$touch()"
                        >
                        </model-list-select>
                    </b-form-group>
                </b-col> -->
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label class="required">Tipo do Movimento</label>
                        <b-form-select
                            :options="tipoMovimentoOptions"
                            v-model="tipoMovimento"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Status do contrato</label>
                        <b-form-select
                            :options="statusContratoRmOptions"
                            v-model="statusContratoRm.codigo"
                            text-field="descricao"
                            value-field="codigo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <!-- <b-col sm="12" md="3">
                    <b-form-group>
                        <label
                            class="required"
                        >Departamento</label>
                        <b-form-select
                            :options="filteredDepartamentos"
                            v-model="departamento.codigo"
                            text-field="nome"
                            value-field="codigo"
                            @input="$v.departamento.codigo.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label
                            class="required"
                        >Gestor do contrato</label>
                        <b-form-select
                            :options="fornecedores"
                            v-model="gestorContrato.codigo"
                            text-field="nome"
                            value-field="codigo"
                            @input="$v.gestorContrato.codigo.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label
                            class="required"
                        >Gerente do gestor</label>
                        <b-form-select
                            :options="fornecedores"
                            v-model="gerenteGestor.codigo"
                            text-field="nome"
                            value-field="codigo"
                            @input="$v.gerenteGestor.codigo.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Representante</label>
                        <model-list-select
                            :list="representantes"
                            option-text="nome"
                            option-value="codigo"
                            v-model="representante.codigo"
                            @input="$v.representante.codigo.$touch()"
                        >
                        </model-list-select>
                    </b-form-group>
                </b-col> -->
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label class="required">Natureza do Contrato</label>
                        <b-form-select
                            :options="naturezaContratoOptions"
                            v-model="codNaturezaContrato"
                            text-field="descricao"
                            value-field="codigo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Conta</label>
                        <b-form-select
                            :options="filteredContas"
                            v-model="conta.codigo"
                            text-field="descricao"
                            value-field="codigo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <!-- <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Despesa/Receita</label>
                        <b-form-select
                            :options="despesasReceitas"
                            v-model="despesaReceita.codigo"
                            text-field="descricao"
                            value-field="codigo"
                        ></b-form-select>
                    </b-form-group>
                </b-col> -->
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="diaFat">Dia de Faturamento</label>
                        <b-input-group>
                            <b-form-input
                                type="number"
                                id="diaFat"
                                placeholder="Digite o o dia do faturamento"
                                v-model="diaFaturamento"
                                v-mask="'##'"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="diaCarFat"
                            >Dia de Carencia para Faturamento</label
                        >
                        <b-input-group>
                            <b-form-input
                                type="number"
                                id="diaCarFat"
                                placeholder="Digite o dia de carencia para faturamento"
                                v-model="diasCarenciaFaturamento"
                                v-mask="'##'"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="diaCarCancFat"
                            >Dia de Carencia para Cancelar Faturamento</label
                        >
                        <b-input-group>
                            <b-form-input
                                type="number"
                                id="diaCarCancFat"
                                placeholder="Digite o dia de Carencia para Cancelar Faturamento"
                                v-model="diasCarenciaCancFaturamento"
                                v-mask="'##'"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col sm="25" md="4">
                    <b-form-group>
                        <label>Campo livre 1</label>
                        <b-form-textarea
                            v-model="campoLivre1"
                            :maxlength="40"
                        ></b-form-textarea>
                    </b-form-group>          
                </b-col>
                <b-col sm="25" md="4">
                    <b-form-group>
                        <label>Campo livre 2</label>
                        <b-form-textarea
                            v-model="campoLivre2"
                            :maxlength="40"
                        ></b-form-textarea>
                    </b-form-group>          
                </b-col>
                <b-col sm="25" md="4">
                    <b-form-group>
                        <label>Campo livre 3</label>
                        <b-form-textarea
                            v-model="campoLivre3"
                            :maxlength="40"
                        ></b-form-textarea>
                    </b-form-group>          
                </b-col>
            </b-row> -->
            <b-row>
                <b-col sm="25" md="4">
                    <b-form-group>
                        <label>Observação</label>
                        <b-form-textarea
                            v-model="observacao"
                            :maxlength="40"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
        <b-card-footer>
            <b-button variant="danger" @click.stop="voltar()" class="mr-1">
                <span> <i class="fa fa-history"></i> Cancelar </span>
            </b-button>
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                @click.stop="confirmaSalvar()"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratoRmServicos from '../../rm/ContratosRMServicos'
import ContratosServicos from '../ContratosServicos'
import { ModelListSelect } from 'vue-search-select'

export default {
    components: {
        ModelListSelect
    },

    data() {
        return {
            campoLivreMask: 'X'.repeat(40),
            id: '',
            contrato: {},
            tiposContratoRm: [],
            tipoContratoRm: {
                codigo: '',
                descricao: ''
            },
            tiposProdutosFaturamentoRm: [],
            tipoProdutoFaturamentoRm: {
                codigo: '',
                descricao: ''
            },
            tiposNatureza: [],
            tipoNatureza: {
                codigo: '',
                descricao: ''
            },
            vendedores: [],
            fornecedores: [],
            gestorContrato: {
                codigo: '',
                nome: ''
            },
            gerenteGestor: {
                codigo: '',
                nome: ''
            },
            representantes: [],
            representante: {
                codigo: '',
                nome: ''
            },
            departamentos: [],
            departamento: {
                codigo: '',
                nome: ''
            },
            erros: [],
            operacao: 'ATUALIZAR',
            tipoMovimentoOptions: [],
            tipoMovimento: '1.1.04',
            // TODO: mover listagem para o devido lugar
            naturezaContratoOptions: [
                {
                    codigo: 0,
                    descricao: 'Venda'
                },
                {
                    codigo: 1,
                    descricao: 'Compra'
                }
                // {
                // codigo: 2,
                // descricao: "Ambos"
                // }
            ],
            codNaturezaContrato: '',
            naturezaContrato: {
                codigo: 0,
                descricao: ''
            },
            contas: [],
            conta: {
                codigo: '',
                descricao: ''
            },
            despesasReceitas: [],
            despesaReceita: {
                codigo: '',
                descricao: ''
            },
            statusContratoRmOptions: [],
            statusContratoRm: {
                codigo: '',
                descricao: ''
            },
            filiais: [],
            filial: {
                codigo: 1,
                nomeFantasiaFilial: 'Matriz'
            },
            diaFaturamento: 0,
            diasCarenciaFaturamento: 0,
            diasCarenciaCancFaturamento: 0,
            campoLivre1: '',
            campoLivre2: '',
            campoLivre3: '',
            observacao: ''
        }
    },
    methods: {
        obterInformacoesContrato() {
            this.$store.dispatch('addRequest')
            ContratoRmServicos.obterInformacoesComplementaresContratoRM().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.statusContratoRmOptions =
                                response.data.statusContratoRMDtoOptions
                            this.tiposContratoRm =
                                response.data.tiposContratoRMDto
                            this.tiposProdutosFaturamentoRm =
                                response.data.tiposProdutoFaturamentoRmDto
                            this.condicoesPagamentoRm =
                                response.data.condicoesPagamentoRMDto
                            this.tiposNatureza = response.data.tiposNaturezaDto
                            this.vendedores = response.data.vendedoresRMDto
                            this.fornecedores =
                                response.data.fornecedoresGestorRMDto
                            this.representantes =
                                response.data.representantesRMDto
                            this.departamentos =
                                response.data.departamentosRMDto
                            this.contas = response.data.contasRMDto
                            this.despesasReceitas =
                                response.data.despesasReceitasRMDto
                            this.filiais = response.data.filiaisRMDto
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterTiposMovimentos() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterTiposMovimentos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tipoMovimentoOptions = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        buscaElemento(colecao, elementoCod) {
            return colecao.find((x) => x.codigo == elementoCod)
        },

        confirmaSalvar() {
            this.$store.dispatch('addRequest')
            this.tipoContratoRm = this.buscaElemento(
                this.tiposContratoRm,
                this.tipoContratoRm.codigo
            )
            this.tipoProdutoFaturamentoRm = this.buscaElemento(
                this.tiposProdutosFaturamentoRm,
                this.tipoProdutoFaturamentoRm.codigo
            )
            this.tipoNatureza = this.buscaElemento(
                this.tiposNatureza,
                this.tipoNatureza.codigo
            )
            // this.gestorContrato = this.buscaElemento(
            //     this.fornecedores,
            //     this.gestorContrato.codigo
            // )
            // this.gerenteGestor = this.buscaElemento(
            //     this.fornecedores,
            //     this.gerenteGestor.codigo
            // )
            // this.representante = this.buscaElemento(
            //     this.representantes,
            //     this.representante.codigo
            // )
            this.naturezaContrato = this.buscaElemento(
                this.naturezaContratoOptions,
                this.codNaturezaContrato
            )
            // this.departamento = this.buscaElemento(
            //     this.filteredDepartamentos,
            //     this.departamento.codigo
            // )
            this.conta = this.buscaElemento(
                this.filteredContas,
                this.conta.codigo
            )
            // this.despesaReceita = this.buscaElemento(
            //     this.despesasReceitas,
            //     this.despesaReceita.codigo
            // )
            this.statusContratoRm = this.buscaElemento(
                this.statusContratoRmOptions,
                this.statusContratoRm.codigo
            )
            this.filial = this.buscaElemento(this.filiais, this.filial.codigo)
            let dadosRmDto = {
                filialRMDto: this.filial,
                id: this.id,
                contratoId: this.$route.params.contratoId,
                tipoContratoRMDto: this.tipoContratoRm,
                // tipoProdutoFaturamentoRmDto: this.tipoProdutoFaturamentoRm,
                tipoNaturezaDto: this.tipoNatureza,
                // gestorContrato: this.gestorContrato,
                // gerenteGestor: this.gerenteGestor,
                // representanteRMDto: this.representante,
                tipoMovimento: this.tipoMovimento,
                naturezaContratoRMDto: this.naturezaContrato,
                // departamentoRMDto: this.departamento,
                contaRMDto: this.conta,
                // despesaReceitaRMDto: this.despesaReceita,
                statusContratoRMDto: this.statusContratoRm,
                diaFaturamento: this.diaFaturamento,
                diasCarenciaFaturamento: this.diasCarenciaFaturamento,
                diasCarenciaCancFaturamento: this.diasCarenciaCancFaturamento,
                // campoLivre1: this.campoLivre1,
                // campoLivre2: this.campoLivre2,
                // campoLivre3: this.campoLivre3,
                observacao: this.observacao
            }
            ContratoRmServicos.inserirDadosRm(dadosRmDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Dados do RM inseridos com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.voltar()
                    } else {
                        this.$toast.error(
                            'Erro ao atualizar dados do RM',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
            })
            this.$store.dispatch('removeRequest')
        },

        preencheForm(dadosContratoRM) {
            this.id = dadosContratoRM.id
            this.filial.codigo = dadosContratoRM.filialRMDto.codigo
            this.tipoContratoRm.codigo =
                dadosContratoRM.tipoContratoRMDto.codigo
            // this.tipoProdutoFaturamentoRm.codigo = dadosContratoRM.tipoProdutoFaturamentoRmDto.codigo
            // this.tipoNatureza.codigo = dadosContratoRM.tipoNaturezaDto.codigo
            // this.gestorContrato.codigo = dadosContratoRM.gestorContrato.codigo
            // this.gerenteGestor.codigo = dadosContratoRM.gerenteGestor.codigo
            // this.representante.codigo = dadosContratoRM.representanteRMDto.codigo
            this.tipoMovimento = dadosContratoRM.tipoMovimento
            this.codNaturezaContrato =
                dadosContratoRM.naturezaContratoRMDto.codigo
            this.naturezaContrato = dadosContratoRM.naturezaContratoRMDto
            // this.departamento.codigo = dadosContratoRM.departamentoRMDto.codigo
            this.conta.codigo = dadosContratoRM.contaRMDto.codigo
            this.despesaReceita.codigo =
                dadosContratoRM.despesaReceitaRMDto.codigo
            this.statusContratoRm.codigo =
                dadosContratoRM.statusContratoRMDto.codigo
            this.diaFaturamento = dadosContratoRM.diaFaturamento
            this.diasCarenciaFaturamento =
                dadosContratoRM.diasCarenciaFaturamento
            this.diasCarenciaCancFaturamento =
                dadosContratoRM.diasCarenciaCancFaturamento
            // this.campoLivre1 = dadosContratoRM.campoLivre1
            // this.campoLivre2 = dadosContratoRM.campoLivre2
            // this.campoLivre3 = dadosContratoRM.campoLivre3
            this.observacao = dadosContratoRM.observacao
        },

        obterDadosRM() {
            ContratoRmServicos.obterDadosContratoRM(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success && response.data != null) {
                        this.preencheForm(response.data)
                    }
                }
            })
        },

        voltar() {
            this.erros = []
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        }
    },

    created() {
        this.obterInformacoesContrato()
        this.obterDadosRM()
        this.obterTiposMovimentos()
        // this.obterDados()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        filteredContas() {
            // return this.contas.filter(c => {
            //     return c.codFilial == this.filial.codigo
            // });
            return this.contas
        },

        filteredDepartamentos() {
            return this.departamentos.filter((d) => {
                return d.codFilial == this.filial.codigo
            })
        }
    },

    watch: {
        diaFaturamento(dia) {
            if (dia > 30) {
                this.diaFaturamento = 30
            }
        },

        diasCarenciaFaturamento(dia) {
            if (dia > 30) {
                this.diasCarenciaFaturamento = 30
            }
        },

        diasCarenciaCancFaturamento(dia) {
            if (dia > 30) {
                this.diasCarenciaCancFaturamento = 30
            }
        }

        // 'filial.codigo'(a,b){
        //     // console.log(a);
        // }
    },

    validations: {
        tipoContratoRm: {
            codigo: {
                required
            }
        },

        // tipoProdutoFaturamentoRm: {
        //     codigo: {
        //         required
        //     }
        // },

        // tipoNatureza: {
        //     codigo: {
        //         required
        //     }
        // },

        // gestorContrato: {
        //     codigo: {
        //         required
        //     }
        // },

        // departamento: {
        //     codigo: {
        //         required
        //     }
        // },

        // gerenteGestor: {
        //     codigo: {
        //         required
        //     }
        // },

        // representante: {
        //     codigo: {
        //         required
        //     }
        // },

        tipoMovimento: {
            required
        },

        filial: {
            codigo: {
                required
            }
        },

        codNaturezaContrato: {
            required
        }
    }
}
</script>
